import { BaseModel } from '../../core/base/base.model';
import { ISelectOption } from '../interfaces/select-option.interface';
import { CompanyModel } from './company.model';

export class ConfigModel extends BaseModel {
  key: string;
  value: string;

  companyId: number | null;

  // Relations
  company: CompanyModel | null;

  constructor(obj: any) {
    super(obj);
    this.key = obj?.key ?? '';
    this.value = obj?.value ?? '';

    this.companyId = obj?.companyId ?? null;

    // Relations
    this.company = obj?.company ? new CompanyModel(obj.company) : null;
  }

  override toForm(): any {
    return {
      value: this.value,
    };
  }

  override toSelect(): ISelectOption {
    return {
      label: this.key,
      value: this.id,
    };
  }
}
